import {useAttributes} from "~/composables/useAttributes"
import {tableStores} from "~/store/tableModules"

export const useTableFeatures = (module: string) => {
    const tableStore = tableStores[module] ? tableStores[module]() : undefined

    const fetchData = (refresh?: boolean) => {
        if (!tableStore) return
        tableStore.fetchData(refresh)
    }

    const {ta} = useAttributes(module)

    function getAttributeTranslation(attribute: string) {
        return ta(attribute)
    }

    return {
        tableStore,
        getAttributeTranslation,
        fetchData
    }
}
